import { render, staticRenderFns } from "./footerItem.vue?vue&type=template&id=e514ab0e&scoped=true"
import script from "./footerItem.vue?vue&type=script&lang=js"
export * from "./footerItem.vue?vue&type=script&lang=js"
import style0 from "./footerItem.vue?vue&type=style&index=0&id=e514ab0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e514ab0e",
  null
  
)

export default component.exports